var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatWithStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16242_493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 9H16",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13H12.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.325 19.605L8 21V18H3V4M4 4H21V11.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0028 20.6332L15.5305 22L16.0028 19.105L14 17.055L16.7639 16.6338L18 14L19.2361 16.6338L22 17.055L19.9972 19.105L20.4695 22L18.0028 20.6332Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16242_493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatWithStar);
export default __webpack_public_path__ + "static/media/chat-with-star.d1396c5f3b5a2b22ed1fcb8a409238dc.svg";
export { ForwardRef as ReactComponent };